module.exports = __webpack_public_path__ + "img/GAME_OXQUIZ1.42dbf6aa.jpg";